import { HttpClient, HttpResponseBase } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError as _observableThrow } from "rxjs";
import {
    catchError as _observableCatch,
    mergeMap as _observableMergeMap,
} from 'rxjs/operators';
import { CheckExistQueueInput, GetBranchCodeModel, GetInfoQueueModel, GetInfomationCustomerModel, GetQueueBookingForTabletModel } from '../models/queues-get.models';
import { ApiResponse, Customer, ProductGroup } from '../models/queues-response.models';
import { BaseService } from '../shared/base.service';
import { MainService } from '../shared/main.service';
import { API, HANDSHAKE } from "../utils/constants";
import { OptionsType } from '../utils/handshake.model';
import { ConfigService } from "./config.service";

@Injectable({
    providedIn: 'root'
})

export class QueuesService {
    API_URL: string;
    isHandShakeFlg: boolean;

    constructor(
        private http: HttpClient,
        private mainService: MainService,
        private baseService: BaseService,
        private configSevice: ConfigService
    ) {
        this.isHandShakeFlg = this.configSevice.get(HANDSHAKE);
        this.API_URL = this.configSevice.get(API);
    }

    getCustomerByPhone(model: GetInfomationCustomerModel): Observable<ApiResponse<Customer>> {
        let url = this.API_URL + 'Queues/CheckCustomerByPhone';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    getCustomerByDoc(model: GetInfomationCustomerModel): Observable<ApiResponse<Customer>> {
        let url = this.API_URL + 'Queues/CheckCustomerByDoc';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    getCustomerByCode(model: GetInfomationCustomerModel): Observable<ApiResponse<Customer>> {
        let url = this.API_URL + 'Queues/CheckCustomerByCode';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // Check booking code
    getQueueBooking(model: GetQueueBookingForTabletModel): Observable<ApiResponse<Customer>> {
        let url = this.API_URL + 'Queues/CheckBooking';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // CheckQueueInCache
    getQueueInCache(model: GetBranchCodeModel): Observable<ApiResponse<any>> {
        let url = this.API_URL + 'Queues/CheckQueueInCache';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // getBranchInfo
    getBranchInfo(orgCode: string): Observable<ApiResponse<any>> {
        let url = this.API_URL + 'Queues/GetBranchInfo';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url,
            { "OrgCode": orgCode },
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // CheckExistQueue
    getExistQueue(model: GetInfoQueueModel): Observable<ApiResponse<any>> {
        let url = this.API_URL + 'Queues/CheckExistQueueBooking';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    checkExistQueue(model: CheckExistQueueInput): Observable<ApiResponse<any>> {
        let url = this.API_URL + 'Queues/CheckExistQueue';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // CreateQueue
    createNewQueue(model: Customer): Observable<ApiResponse<string>> {
        let url = this.API_URL + 'Queues/CreateQueueBooking';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // CreateQueue
    createNewQueueForTablet(model: Customer): Observable<ApiResponse<string>> {
        let url = this.API_URL + 'Queues/CreateNewQueueTablet';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // GetAllProductGroups
    getProductGroups(branchCode: string): Observable<ProductGroup[]> {
        let url = this.API_URL + 'Queues/GetAllProductGroups';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url,
            { BranchCode: branchCode },
            null,
            func,
            this.isHandShakeFlg,
        )
    }
}